import ImageCarousel from "../components/imageCarousel.tsx";
import { Helmet } from "react-helmet-async";

const collection = [
  {
    title: "Audi Q8",
    description: [
      "Am avut plăcerea de a repara un Audi Q8 care a suferit daune severe, atât mecanice, cât și la nivelul caroseriei. Echipa noastră a lucrat cu profesionalism și atenție la fiecare detaliu pentru a readuce mașina la starea sa impecabilă.",
      "Din punct de vedere mecanic, toate componentele afectate au fost înlocuite sau reparate cu piese originale, asigurând performanța optimă.",
      "În ceea ce privește caroseria, am restaurat fiecare panou afectat și am aplicat o vopsea de calitate superioară, perfect aliniată cu nuanța originală.",
      "Rezultatul final este spectaculos: un Audi Q8 care arată și funcționează ca nou, gata să impresioneze din nou pe drumuri! 🚗✨",
    ],
    images: [
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p1.webp?updatedAt=1739733175962",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p2.webp?updatedAt=1739733175960",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p3.webp?updatedAt=1739733175934",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p4.webp?updatedAt=1739733176094",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p5.webp?updatedAt=1739733176098",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p6.webp?updatedAt=1739733176074",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p7.webp?updatedAt=1739733176116",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p8.webp?updatedAt=1739733176094",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p9.webp?updatedAt=1739733176211",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p10.webp?updatedAt=1739733176148",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p11.webp?updatedAt=1739733179194",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p12.webp?updatedAt=1739733179165",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p13.webp?updatedAt=1739733179203",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p14.webp?updatedAt=1739733179194",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p15.webp?updatedAt=1739733179230",
      "https://ik.imagekit.io/gabylenautoservice/audiQ8/p16.webp?updatedAt=1739733179225",
    ],
  },
  {
    title: "Range Rover Sport",
    description: [
      "Am avut provocarea de a repara un Range Rover avariat grav, cu roata complet smulsă. Această reparație a fost un test de măiestrie pentru echipa noastră, necesitând eforturi intense atât pe partea de tinichigerie, cât și pe cea mecanică și electronică, datorită numărului mare de senzori implicați.",
      "Structura caroseriei a fost complet restaurată, fiecare panou fiind ajustat cu precizie pentru a reda forma originală a vehiculului. Partea mecanică a fost reparată folosind componente originale, iar suspensia, sistemul de direcție și ansamblul roții au fost reconfigurate cu exactitate.",
      "În plus, sistemele electronice avansate ale mașinii, inclusiv senzorii, au fost recalibrate pentru a asigura o funcționare perfectă. Rezultatul? Un Range Rover care arată și funcționează impecabil, pregătit să își reia locul pe șosea! 🚙✨",
    ],
    images: [
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240125_101648.webp?updatedAt=1739656439772",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240127_134323.webp?updatedAt=1739656439964",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240125_101708.webp?updatedAt=1739656439979",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140538.webp?updatedAt=1739656439825",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140650.webp?updatedAt=1739656439948",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140653.webp?updatedAt=1739656439965",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240225_134746.webp?updatedAt=1739656440019",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140548.webp?updatedAt=1739656440015",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140511.webp?updatedAt=1739656439978",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140527.webp?updatedAt=1739656440022",
      "https://ik.imagekit.io/gabylenautoservice/rangerover/20240308_140557.webp?updatedAt=1739656442590",
    ],
  },
];
const PortfolioPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Reparații Profesionale Caroserie și Mecanică | GabyLen Autoservice &
          ITP Florești
        </title>
        <meta
          name="description"
          content="Descoperă portofoliul nostru impresionant de lucrări auto, ilustrat prin imagini captivante și detalii despre fiecare reparație. De la reparații de caroserie până la intervenții mecanice complexe, oferim calitate și profesionalism în fiecare proiect realizat. Navighează printre slide-uri și inspiră-te din munca noastră!"
        />
        <meta
          name="keywords"
          content="portofoliu auto, reparații auto, lucrări caroserie, reparații mecanice, imagini reparații, tinichigerie auto, atelier auto modern"
        />
      </Helmet>
      <div className="bg-gray-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {collection.map((collection) => (
            <ImageCarousel {...collection} key={collection.title} />
          ))}
        </div>
      </div>
    </>
  );
};
export default PortfolioPage;
